import { Dialog } from "construct-ui";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import SelectSiteComponent from "../../../components/site/select-site.component";
import { DIRECT_PURCHASE } from "../../../config/constants";
import GscmDivisionModel from "../../../models/gscm-division/gscm-division.model";
import ShipToModel from "../../../models/ship-to/ship-to.model";
import SiteSoldToShipToMappingModel from "../../../models/sold-to-ship-to/site-sold-to-ship-to-mapping.model";
import SoldToModel from "../../../models/sold-to/sold-to.model";
import ViewBase from "../../view-base.view";

export default function SiteSoldToShipToAddView() {
  ViewBase.call(this);

  let onClose = (e) => { };
  let onSaveComplete = (e) => { };
  let data = null;

  let PAGINATION_UNLIMITED = {
    pageIndex: 1,
    pageSize: 0,
  };

  let _selectedSite = [];
  let _selectedGscmDivision = {};
  let _selectedSoldToCode = {};
  let _selectedShipToCode = {};
  let _selectedDirectPurchase = {};

  let gscmDivisionOptionList = [];
  let soldToCodeOptionList = [];
  let shipToCodeOptionList = [];
  let directPurchaseOptionList = Object.values(DIRECT_PURCHASE).map(
    (element) => ({
      sequence: 0,
      code: element,
      name: element,
    })
  );

  const _mappingDataUpload = (param) => {
    return Object.assign({
      siteId: param.siteId,
      toBeGscmDivision: param.gscmDivision,
      toBeSoldToCode: param.soldToCode,
      toBeShipToCode: param.shipToCode,
      toBeDistributionStoreType: param.distributionStoreType,
    });
  };

  const _isAllInputsValid = () => {
    if (_selectedSite.length == 0) {
      this.showErrorMessage(this.getText("EM00000250", "Please select a site id"));

      return false;
    }
    if (_selectedGscmDivision.code === '' || _selectedGscmDivision.code === undefined) {
      console.log(_selectedGscmDivision);
      this.showErrorMessage(this.getText("LT00000857", "Please select a GSCM division"));

      return false;
    }
    if (_selectedSoldToCode.code === '' || _selectedSoldToCode.code === undefined) {
      this.showErrorMessage(this.getText("LT00000858", "Please select a sold-to code"));

      return false;
    }
    if (_selectedShipToCode.code === '' || _selectedShipToCode.code === undefined) {
      this.showErrorMessage(this.getText("LT00000859", "Please select a ship-to code"));

      return false;
    }
    if (_selectedDirectPurchase.code === '' || _selectedDirectPurchase.code === undefined) {
      this.showErrorMessage(
        this.getText("LT00000860", "Please select a direct purchase from Samsung")
      );

      return false;
    }

    return true;
  };

  const _save = () => {
    let _valid = _isAllInputsValid();
    if (_valid) {
      _saveMapping();
    }
  };

  const _saveMapping = () => {
    let payload = {
      siteId: _selectedSite[0].code, // don't have conform component for single select
      gscmDivision: _selectedGscmDivision.code,
      soldToCode: _selectedSoldToCode.code,
      shipToCode: _selectedShipToCode.code,
      distributionStoreType: _selectedDirectPurchase.code.toUpperCase(),
    };

    if (data != null) {
      SiteSoldToShipToMappingModel.updateMapping({
        ..._mappingDataUpload(payload),
        ...data,
      })
        .then(onSaveComplete)
        .catch((error) => {
          this.handleError(error);
        });
    } else {
      SiteSoldToShipToMappingModel.createMapping(payload)
        .then(onSaveComplete)
        .catch((error) => {
          this.handleError(error);
        });
    }
  };

  const _cancel = (e) => {
    onClose(e);
  };

  const getGscmDivisionList = () => {
    return GscmDivisionModel.getGscmDivisions();
  };

  const getSoldToCodeList = () => {
    return SoldToModel.getListSoldToCode('', PAGINATION_UNLIMITED)
      .then((result) => {
        return result.data.map((e) => ({ code: e.soldToCode, name: e.soldToName }));
      });;
  };

  const getShipToCodeList = () => {
    return ShipToModel.getListShipToCode();
  };

  const renderShipToSoldToName = (shipToSoldTo) => {
    return shipToSoldTo.name
      ? `${shipToSoldTo.name} [${shipToSoldTo.code}]`
      : `[${shipToSoldTo.code}]`;
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }
      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }
      data = vnode.attrs.data;

      this.showLoading();

      Promise.all([
        getGscmDivisionList(),
        getSoldToCodeList(),
        getShipToCodeList(),
      ])
        .then((result) => {
          gscmDivisionOptionList = result[0] || [];
          soldToCodeOptionList = result[1]?.map(e => ({ code: e.code, name: renderShipToSoldToName(e) })) || [];
          shipToCodeOptionList = result[2]?.map(e => ({ code: e.code, name: renderShipToSoldToName(e) })) || [];

          if (data) {
            _selectedSite = [{ code: data.siteId, name: '' }];

            if (gscmDivisionOptionList.length > 0) {
              _selectedGscmDivision = gscmDivisionOptionList.find(
                (e) => e.name == data.gscmDivision
              );
            }
            if (soldToCodeOptionList.length > 0) {
              _selectedSoldToCode = soldToCodeOptionList.find(
                (e) => e.code == data.soldToCode
              );
            }
            if (shipToCodeOptionList.length > 0) {
              _selectedShipToCode = shipToCodeOptionList.find(
                (e) => e.code == data.shipToCode
              );
            }
            if (directPurchaseOptionList.length > 0) {
              _selectedDirectPurchase = directPurchaseOptionList.find(
                (e) => e.code == data.distributionStoreType
              );
            }
          }
        })
        .catch(this.handleError)
        .finally(this.hideLoading);
    },
    view: (vnode) => {
      return m(Dialog, {
        class: "cui-dialog-lg",
        isOpen: vnode.attrs.isModalMappingOpen,
        transitionDuration: 200,
        closeOnOutsideClick: false,
        onClose: vnode.attrs.onClose,
        title:
          vnode.attrs.data == null
            ? this.getText("LT00000855", "Register New Mapping")
            : this.getText("LT00000856", "Update Mapping"),
        content: [
          m(".row",
            m("col-md-12",
              m(".card",
                m(".card-body",
                  m(".row",
                    m(".col-md-6.g-3",
                      m("label.form-label.mandatory", this.getText("LT00000071", "Site")),
                      m(SelectSiteComponent, {
                        selectedItemList: _selectedSite,
                        onChange: (s) => {
                          _selectedSite = s;
                        },
                        disabled: !!vnode.attrs.data
                      })
                    ),
                    m(".col-md-6.g-3",
                      m("label.form-label.mandatory",
                        this.getText("LT00000241", "GSCM Division")
                      ),
                      m(SingleSelectComponent, {
                        id: "gscmDivision",
                        items: gscmDivisionOptionList,
                        checkmark: true,
                        filterable: true,
                        required: true,
                        selectedItem: _selectedGscmDivision,
                        onSelect: (s) => {
                          _selectedGscmDivision = s;
                        },
                        disabled: !!vnode.attrs.data
                      })
                    ),
                    m(".col-md-6.g-3",
                      m("label.form-label.mandatory", this.getText("LT00000847", "Sold-To Code")),
                      m(SingleSelectComponent, {
                        id: "soldToCode",
                        items: soldToCodeOptionList,
                        checkmark: true,
                        filterable: true,
                        required: true,
                        selectedItem: _selectedSoldToCode,
                        onSelect: (s) => {
                          _selectedSoldToCode = s;
                        },
                      })
                    ),
                    m(".col-md-6.g-3",
                      m("label.form-label.mandatory", this.getText("LT00000849", "Ship-To Code")),
                      m(SingleSelectComponent, {
                        id: "shipToCode",
                        items: shipToCodeOptionList,
                        checkmark: true,
                        filterable: true,
                        required: true,
                        selectedItem: _selectedShipToCode,
                        onSelect: (s) => {
                          _selectedShipToCode = s;
                        },
                      })
                    ),
                    m(".col-md-6.g-3",
                      m("label.form-label.mandatory",
                        this.getText("LT00000851", "Direct Purchase from Samsung")
                      ),
                      m(SingleSelectComponent, {
                        id: "directPurchase",
                        items: directPurchaseOptionList,
                        checkmark: true,
                        filterable: true,
                        required: true,
                        selectedItem: _selectedDirectPurchase,
                        onSelect: (s) => {
                          _selectedDirectPurchase = s;
                        },
                      })
                    )
                  )
                ),
                m(".card-footer",
                  m(".col-md-12.gap-2.d-flex.justify-content-center",
                    m("button.btn.btn-primary[type='button']",
                      { onclick: _save },
                      this.getText("LT00000022", "Save")
                    ),
                    m("button.btn.btn-white[type='button']",
                      { onclick: _cancel },
                      this.getText("LT00000021", "Close")
                    )
                  )
                )
              )
            )
          ),

          this.getBaseViews(),
        ],
      });
    },
  };
}
